import {Route, Switch, Redirect} from "react-router-dom"
import React from "react"
import withProps from "recompose/withProps"
import {containers} from "@swarm2/core"
import {
  AuthCharacterListView,
  CharacterListView,
  CharacterRouter,
  Start,
  NewCharacter,
} from "../characters"
import {AuthUserView, UserView} from "../users"
import {DebugView} from "../debug"
import {Layout} from "./Layout"
import * as Util from "../common"
import {OptionsView} from "../options"
import {RankingsRouter} from "../rankings"
import AuthRouter, {AuthEmailActionRedirect} from "../auth-signin"
import BetaRouter from "../beta"
import TitleView from "./TitleView"
import Privacy from "./PrivacyView"

const ROCharacterRouter = withProps({readonly: true})(CharacterRouter)
const RWCharacterRouter = withProps({readonly: false})(CharacterRouter)

const AuthedRoute = containers.app.withAuth(function AuthedRoute(props) {
  const {isPending, isAllowed, path} = props
  // don't ever interrupt the loading process
  if (isPending) return <Route {...props} />
  if (!isAllowed) return <Redirect to="/" from={path} />
  return <Route {...props} />
})
export const AppRoutes = function AppRoutes() {
  return (
    <Switch>
      <Route exact path="/" component={TitleView} />
      <Route path="/auth" component={AuthRouter} />
      <Route path="/beta" component={BetaRouter} />
      <Route path="/privacy" component={Privacy} />
      {/* Firebase uses the same path in every email template, so we'll redirect emails to a prettier path here. */}
      <Route path="/__/auth/action" component={AuthEmailActionRedirect} />

      <AuthedRoute exact path="/start" component={Start} />

      <AuthedRoute path="/u/:userId/characters" component={CharacterListView} />
      <AuthedRoute path="/u/:userId" component={UserView} />
      <AuthedRoute path="/c/:charId" component={ROCharacterRouter} />

      <AuthedRoute exact path="/me/characters/new" component={NewCharacter} />
      <AuthedRoute path="/me/characters" component={AuthCharacterListView} />
      <AuthedRoute path="/me" component={AuthUserView} />
      {/* duplicate links to non-char pages avoid losing character in nav links.
        TODO: clean this up by adding routing under PlayView.
        Look at DebugView <Route>s for an example.
    */}
      <AuthedRoute path="/options" component={OptionsView} />
      <AuthedRoute path="/p/:charId/options" component={OptionsView} />
      <AuthedRoute path="/debug" component={DebugView} />
      <AuthedRoute path="/p/:charId/debug" component={DebugView} />

      <AuthedRoute path="/p/:charId" component={RWCharacterRouter} />

      <AuthedRoute path="/rankings" component={RankingsRouter} />

      <AuthedRoute component={Util.NotFoundView} />
    </Switch>
  )
}
export default () => (
  <Layout>
    <AppRoutes />
  </Layout>
)



// WEBPACK FOOTER //
// ./src/app/Router.js